export default __webpack_public_path__ + "static/media/icon-disconnect.59ddf93b.svg";